module.exports = __webpack_public_path__ + "static/media/mmapp.57ae9cd3.jpg";